export { BadgeComponent, BadgeThemePalette, type badgeThemePalette } from './badge.component';
export { NotificationBadgeComponent } from './notification-badge.component';
